/**
 * Type-safe access to CSS palette custom properties
 */

export const palette = {
  border: {
    secondary: "var(--palette-border-secondary)",
  },
  text: {
    primary: "var(--palette-text-primary)",
  },
} as const;

export type PaletteKeys = keyof typeof palette;
export type PaletteBorderKeys = keyof typeof palette.border;
export type PaletteTextKeys = keyof typeof palette.text;
